import { SessionService } from "../../shared/service/session.service";
import { RequestService } from "../../shared/service/request.service";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

@Injectable()
export class ErrorhandleService {
  constructor(
    public sessionService: SessionService,
    private requestService: RequestService,
    private _router: Router
  ) {}

  handle(error: Response): boolean {
    if (error.status === 401 || error.status === 423) {
      alert(
        "Session is expired, Please re login.\n(Code: " + error.status + "')"
      );
      this._redirectToLoginPage();
      return true;
    } else if (error.status === 500) {
      alert("Server Error\n(Code: 500)");
      return true;
    } else if (error.status === 502 || error.status === 504) {
      alert("Server Error\n(CODE " + error.status + "')");
      // this._redirectToLoginPage();
      return true;
    }
    return false;
  }

  private _redirectToLoginPage() {
    try {
      delete this.requestService.enc_pad;
      this.sessionService.clear();
    } catch (err) {}
    this._router
      .navigate(["/admin__/login"], {
        replaceUrl: true,
      })
      .catch((err) => {
        console.log(err);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/service/errorhandle.service.ts